// src/store/live/initial.js
import { HEIGHT, WIDTH } from '~/lib/constants'
import { SETTINGS_VERSION } from '~/lib/migrations'
import { CAMERA_SOURCE, sourceFill } from '~/lib/sourceFill'
import { EFFECT_SCHEMAS } from '~/lib/presetSettings'

/**
 * Every effect PRESENT and EMPTY — `{}` means "present, every param at its initial".
 *
 * ⚠️ Materializing the params instead is the density the sparse model removes: a write that returns a param to its initial DELETES the key, so a seeded value makes boot state a shape no write can ever produce again, and every preset stores knobs the user never touched.
 */
const effectDefaults = Object.fromEntries(Object.keys(EFFECT_SCHEMAS).map(name => [name, {}]))

export default {
	// Settings-shape version. `live` and `preset.settings` are the same shape and round-trip through save/load, so the marker travels with the data. Born current:
	// without it, a preset saved post-cutover looks unmigrated and the migration chain would re-run its steps over data that is already on the current shape.
	_v: SETTINGS_VERSION,
	...effectDefaults,
	objects: {
		root: {
			id: 'root',
			type: 'root',
			children: ['video'],
		},
		video: {
			id: 'video',
			parentId: 'root',
			name: 'Video',
			type: 'rect',
			visible: false,
			width: WIDTH,
			height: HEIGHT,
			fill: sourceFill(CAMERA_SOURCE),
			locked: true,
		},
	},
	// Mirrored by default, a webcam being a self-view.
	source_settings: { [CAMERA_SOURCE]: { mirror: true } },
}
